<template>
  <Flex :class="{ 'router-link-exact-active': isCurrentCategory($route.query.category) }">
    <Flex :class="{ 'cursor-pointer': true }">
      <router-link class="category-link" :to="getRoute(category, selectedSubOption)">
        {{ category.name }}
      </router-link>
    </Flex>
    <DropDown
      :options="category.subOptions"
      :selectedOptionIndex="selectedSubOptionIndex"
      @updateOption="onSubOptionUpdate"
    />
  </Flex>
</template>

<script>
import Flex from '@wizer/core/components/flex/Flex'
import { compact, isEqual } from 'lodash'
import DropDown from '@/components/DropDown'

export default {
  name: 'CategorySelector',
  components: {
    DropDown,
    Flex,
  },
  props: {
    category: Object,
  },
  data() {
    return {
      showMenu: false,
      selectedSubOptionIndex: 0,
      selectedSubOption: this.category.subOptions[0],
    }
  },
  mounted() {
    if (this.isCurrentCategory(this.$route.query.category)) {
      const foundSubOptionIndex = this.category.subOptions.findIndex(
        (subOption) =>
          subOption.attributeValue === this.$route.query.dateFormat ||
          subOption.attributeValue === this.$route.query.level,
      )
      this.selectedSubOptionIndex = foundSubOptionIndex || 0
    }
  },
  methods: {
    onSubOptionUpdate(newSubOption) {
      this.selectedSubOption = newSubOption
      const route = this.getRoute(this.category, this.selectedSubOption)
      if (!isEqual(this.$route.query, route.query)) {
        this.$router.push(route)
      }
    },
    getRoute(category, subOption) {
      const route = {
        name: this.$route.name,
        query: {
          filterQuery: this.$route.query.filterQuery,
          listId: this.$route.query.listId,
          measures: compact([].concat(this.$route.query.measures)),
          calculatedMeasures: compact([].concat(this.$route.query.calculatedMeasures)),
          mapProps: this.$route.query.mapProps,
          smartUrlPrefix: this.$route.query.smartUrlPrefix,
          latitude: this.$route.query.latitude,
          longitude: this.$route.query.longitude,
          location: this.$route.query.location,
          selectedSeries: this.$route.query.selectedSeries,
          serieslevel: this.$route.query.serieslevel,
          wordCloudColumns: this.$route.query.wordCloudColumns,
          category: category.attributePath,
          visualizationId: this.$route.query.visualizationId,
        },
      }
      if (subOption) {
        route.query[subOption.attributeName] = subOption.attributeValue
      }
      return route
    },
    isCurrentCategory(category) {
      return category === this.category.attributePath
    },
  },
}
</script>

<style lang="postcss" scoped>
.category-link {
  @apply break-words;
}
</style>
